// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Post_contentWrapper__uYfEq"};